import React, { useEffect, useState, forwardRef } from "react";
import {
  SFStack,
  SFTypography,
  SFIcons,
  SFButton,
  SFLottieAnimation,
  SFUseStyled,
} from "@sf-core";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Verification_Chart } from "../../../assets";

const { styled } = SFUseStyled();

const StyledSFStack = styled(SFStack)(({ theme }) => ({
  padding: theme.spacing(1),
  height: "100%",
}));

const WelcomeUser = forwardRef((props, ref) => {
  const userAvatar = useSelector((state) => state.session.avatar);
  const [animationData, setAnimationData] = useState(null);
  const { t } = useTranslation();

  // On step load
  useEffect(() => {
    props.setProgressValue(0);
    // If user avatar is available add it to the chart animation data else use the default
    setAnimationData(
      userAvatar
        ? addUserAvatarToChart(Verification_Chart, userAvatar)
        : Verification_Chart
    );
  }, []);

  const onStepClose = () => {
    props.navigateStepFront();
  };

  function addUserAvatarToChart(json, image) {
    // Convert image to base64 if it is not already
    let base64image = getImage(image);
    // Add user avatar image to json chart animation data
    json.assets[0].p = base64image;
    return json;
  }

  const getImage = (image) => {
    // Check if image has already the base64 format else add it
    return image?.includes("data:image/png;base64")
      ? image
      : `data:image/png;base64, ${image}`;
  };

  return (
    <StyledSFStack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={10}
    >
      <SFStack direction="column" spacing={3} justifyContent="center">
        <SFStack direction="column" justifyContent="flex-start" spacing={1}>
          <SFTypography variant={"academyCardTitle"}>
            {t("profileScreen.welcomeUser.title")}
          </SFTypography>
          <SFTypography variant={"body2"}>
            {t("profileScreen.welcomeUser.description")}
          </SFTypography>
        </SFStack>
        <SFStack direction="column" justifyContent="flex-start" spacing={1}>
          <SFStack direction="row" spacing={1.5}>
            <SFIcons.SFTrendingUpIcon />
            <SFTypography variant={"body2"}>
              {t("profileScreen.welcomeUser.track")}
            </SFTypography>
          </SFStack>
          <SFStack direction="row" spacing={1.5}>
            <SFIcons.SFRecommendIcon />
            <SFTypography variant={"body2"}>
              {t("profileScreen.welcomeUser.recommendations")}
            </SFTypography>
          </SFStack>
          <SFStack direction="row" spacing={1.5}>
            <SFIcons.SFPersonAddIcon />
            <SFTypography variant={"body2"}>
              {t("profileScreen.welcomeUser.create")}
            </SFTypography>
          </SFStack>
        </SFStack>
        <SFStack direction="row">
          <SFButton variant="secondary" onClick={() => onStepClose()}>
            {t("profileScreen.welcomeUser.btnStart")}
          </SFButton>
        </SFStack>
      </SFStack>

      {animationData && (
        <SFLottieAnimation animationData={animationData} loop={false} />
      )}
    </StyledSFStack>
  );
});

export default WelcomeUser;
